import { ErrorType } from "@genesys/ui-elements";
import { exhaustiveCheck } from "ts-exhaustive-check";

export function getBackgroundsColor(type: ErrorType) {
  switch (type) {
    case "warning":
      return "#FFF6E1";
    case "none":
      return "#FFFFFF";
    case "error":
      return "#FEEAEB";
    default:
      return exhaustiveCheck(type);
  }
}

export function getBorderColor(type: ErrorType) {
  switch (type) {
    case "warning":
      return "#F0C530";
    case "none":
      return "#FFFFFF";
    case "error":
      return "#E8767B";
    default:
      return exhaustiveCheck(type);
  }
}
